export default __webpack_public_path__ + "static/media/logo.a0530ba9.png";